// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/hospital/style.less
// module id = 246
// module chunks = 0